import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormattedMessage } from 'react-intl';
import useConfig from './hooks/useConfig';
import { useNavigate } from 'react-router-dom';
import RemoveCookies from './RemoveCookies';
import { redirectToAuthPortalLogout, getAuthPortalLoginUrl } from './utils/authPortal';
export default function FailSafeSupport() {
  const [open, setOpen] = React.useState(true);
  const { showLoader, hideLoader } = useConfig();
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
    handleLogout();
  };
  const handleLogout = async () => {
    showLoader();
    try {
      // handle the logout here
      RemoveCookies.removeAccCookies().then((logout) => {
        if (logout) {
          redirectToAuthPortalLogout();
        }
      });
    } catch (err) {
      hideLoader();
      if (process.env.authUrl) {
        window.location.href = getAuthPortalLoginUrl();
      } else {
        navigate('./landingPage');
      }
      console.error(err);
    }
  };

  return (
    <React.Fragment>
      <Dialog open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <FormattedMessage id="error" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {localStorage.getItem('postUserLoginFailMessage') ? localStorage.getItem('postUserLoginFailMessage') : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()} autoFocus>
            <FormattedMessage id="okCommon" />
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
